const styles = theme => {
  return {
    content: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    row: { display: 'flex', alignItems: 'center' },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 0',
      '& button': {
        marginRight: '10px',
        [theme.breakpoints.down('xs')]: {
          marginTop: '10px'
        }
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    emptyBox: { width: '38px' }
  };
};

export default styles;

export const customStyles = {
  root: { marginRight: '0' }
};
